import React from "react";
import styled from "styled-components";
import { DetailedCourse } from "@domain/lms/course/course";
import { DocumentSection } from "@domain/lms/course/courseSection";
import { getAssetById } from "@domain/lms/course/utils";
import { PdfViewer } from "@ui/components/media/pdf/pdfViewer";

interface DocumentSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: DocumentSection;
	course: DetailedCourse;
}
export const DocumentSectionView: React.FC<DocumentSectionViewProps> = ({ section, course, ...htmlProps }) => {
	const asset = getAssetById(course.content, section.assetId);

	if (!asset) {
		return null;
	}
	return (
		<Container {...htmlProps}>
			<PdfViewer source={asset.url} pdfHeight={600} />
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	border-radius: 12px;
	overflow: hidden;
	background-color: ${({ theme }) => theme.colors.white};
`;
